// Point earning (Redeem, Earn, etc.)
export interface EarnPointsRequest {
  customerId: string;
  points: number;
  activityType: string;
  pointType: string;
  orderId?: string;
  campaignId?: string;
  expiryDays?: number;
}

export interface PointTransactionResponse {
  customerId: string;
  transactionId: string;
  timestamp: string;
  pointsDelta: number;
  remainingPoints: number;
  activityType: string;
  pointType: string;
  earnDate: string;
  expireAt: string;
  orderId?: string;
  rewardId?: string;
  campaignId?: string;
}

// Point redemption / Reward exchange
export interface RedeemPointsRequest {
  customerId: string;
  points: number;
  rewardId: string;
}

export interface RedeemPointsResponse {
  success: boolean;
  redeemedPoints: number;
}

// User point balance and tier
export interface CustomerBalanceResponse {
  customerId: string;
  availablePoints: number;
  earned: number;
  redeemed: number;
  tier: string;
  userRegistered?: string;
}

// Transaction history
export interface TransactionHistoryResponse {
  transactions: PointTransactionResponse[];
  lastEvaluatedKey?: string;
}

// Tier update request/response
export interface UpdateTierRequest {
  customerId: string;
  newTier: string;
}

export interface UpdateCustomerTierResponse {
  customerId: string;
  tier: string;
}

// Reward creation/retrieval
export interface CreateRewardRequest {
  name: string;
  description: string;
  pointCost: number;
  status: string;
}

export interface RewardResponse {
  rewardId: string;
  name: string;
  description: string;
  pointCost: number;
  status: string;
  createdAt: string;
  updatedAt?: string;
}

// Tier definition
export interface CreateTierDefinitionRequest {
  tier: string;
  rank: number;
  minPoints: number;
  benefits: string[];
}

export interface TierDefinitionResponse {
  tier: string;
  rank: number;
  minPoints: number;
  benefits: string[];
  createdAt: string;
  updatedAt?: string;
}

// Tier point information for earning calculation
export interface TierPointInfo {
  tier: string;
  pointMultiplier: number;
  pointsPerCurrency: number;
}

// Loyalty policy configuration
export interface LoyaltyPolicyResponse {
  currencyCode: string;
  currencyPerPoint: number;
  pointValueInCurrency: number;
  maxApplicablePointsPercent: number;
  tierPointInfo?: TierPointInfo[];
}
